var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgView = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.522 15.453a1 1 0 0 0 0 1.094C6.23 22.218 10.701 25 16 25c5.3 0 9.77-2.782 13.478-8.453a1 1 0 0 0 0-1.094C25.771 9.782 21.3 7 16 7S6.23 9.782 2.522 15.453M.848 14.358C4.903 8.156 9.975 5 16 5s11.097 3.156 15.152 9.358a3 3 0 0 1 0 3.284C27.097 23.845 22.025 27 16 27S4.903 23.845.848 17.642a3 3 0 0 1 0-3.284M16 22a6 6 0 1 1 0-12 6 6 0 0 1 0 12m0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
})));
export default SvgView;